import { render, staticRenderFns } from "./_forecastHDPList.vue?vue&type=template&id=267f747a&lang=pug&"
import script from "./_forecastHDPList.vue?vue&type=script&lang=js&"
export * from "./_forecastHDPList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports